module.exports = __webpack_public_path__ + "img/elec_day.02581feb.png";